import { makeAutoObservable } from 'mobx';
import { GroupsApi } from '../../api/GroupApi';
import { Contact, NominalCode } from './Entity';
import { CreditNoteType } from '../../config/Constants';
import { PostingType } from './Posting';

export enum ReconciliationType {
  INVOICE = 'invoice',
  CREATE = 'createInvoice',
}

export enum BankTransactionType {
  PAYMENT = 'payment',
  RECEIVED = 'received',
}

export type Invoice = {
  id: number;
  externalId: string;
  organisationId: number;
  type: string;
  issueDate: string;
  dueDate: string;
  total: number;
  currency: string;
  invoiceNumber: string;
  amountDue: number;
  organisationName: string;
  contactName: string;
  contactId: string;
  reference: string;
};

export type Posting = {
  organisationId: number;
  accountCode: string;
  contactId: string;
  contactName: string;
  currency: string;
  amount: number;
  taxRate: string;
  description: string;
  trackingCategories: string[];
  issueDate: string;
  organisationName: string;
  id: number;
  type: ReconciliationType;
  creditNoteType: CreditNoteType;
  postingType: PostingType;
  externalId: string;
};

export type ReconciledObject = {
  type: ReconciliationType;
  invoice: Invoice;
  posting: Posting;
  nominalCode: NominalCode;
  contact: Contact;
  amountPaid: number;
  paymentId?: number;
};

export type BankTransaction = {
  id: string;
  externalId: string;
  accountId: string;
  organisationId: number;
  currency: string;
  created: string;
  amount: number;
  date: string;
  description: string;
  reference: string;
  type: BankTransactionType;
  payee: string;
};

export type ReconciliationLogApiResponse = {
  bankTransaction: BankTransaction;
  reconciliations: ReconciledObject[];
};

export class ReconciliationLogRecord {
  bankTransaction: BankTransaction = null;
  reconciliations: ReconciledObject[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(
    apiData: ReconciliationLogApiResponse
  ): ReconciliationLogRecord {
    const record = new ReconciliationLogRecord();
    record.bankTransaction = apiData.bankTransaction;
    record.reconciliations = apiData.reconciliations;
    return record;
  }
}

export class ReconciliationLog {
  groupId: number = 0;
  loading: boolean = false;
  log: ReconciliationLogRecord[] = [];

  constructor(groupId: number) {
    this.groupId = groupId;
    makeAutoObservable(this);
  }

  load = (): Promise<void> => {
    this.loading = true;
    return GroupsApi.getReconciliationLog(this.groupId).then(logResponse => {
      this.log = logResponse.map(logItem =>
        ReconciliationLogRecord.fromApi(logItem)
      );
      this.loading = false;
    });
  };
}
